const aboutImg = "/lovable-uploads/20211110_38.webp";

export default function About() {
  return (
    <section className="py-20 md:py-28 bg-secondary/40">
      <div className="container grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal">
          <span className="text-accent font-semibold uppercase tracking-wider text-sm">Über uns</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl lg:text-5xl font-bold text-primary text-balance">
            Wer ist FINABLE?
          </h2>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed">
            Wir sind unabhängige Finanzberater mit Fokus auf steueroptimierte Vorsorge und renditeorientierten Vermögensaufbau – komplett digital und bundesweit. Wir helfen Dir, staatliche Förderungen voll auszuschöpfen, legal Steuern zu sparen und Dein Geld so anzulegen, dass es langfristig für Dich arbeitet.
          </p>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
            Kein Bankprodukt, kein Vertriebsdruck – nur die Lösung, die wirklich zu Dir passt.
          </p>

        </div>

        <div className="reveal relative">
          <div className="absolute -inset-4 bg-gradient-accent opacity-20 blur-2xl rounded-3xl" />
          <img
            src={aboutImg}
            srcSet="/lovable-uploads/20211110_38-400.webp 400w, /lovable-uploads/20211110_38-800.webp 800w, /lovable-uploads/20211110_38-1200.webp 1200w"
            sizes="(min-width: 1024px) 600px, 100vw"
            alt="Das FINABLE Beratungsteam in Hamburg"
            width={1600}
            height={1066}
            loading="lazy"
            decoding="async"
            className="relative rounded-2xl shadow-elegant w-full"
          />
        </div>
      </div>
    </section>
  );
}
